import * as angular from 'angular';
import * as _ from 'lodash';

import * as components from './components.index';
import { registerComponents } from '../registration.helper';
import { QualityAnalysisTableHelper } from './QualityAnalysisTable/QualityAnalysisTable.helper';
import { ManualInputsDataService } from './manualInputs/manualInputsData.service';

import * as definitions from './widgets.definition.index';
import { WidgetDefinition } from './models';
import { Miniature } from '../models';
import { IWidgetFactory, WidgetFactory } from './widgetFactory';

export const widgetModuleName = 'wt-widgets-module';

const widgetModule = angular.module(widgetModuleName, [])
    .service(QualityAnalysisTableHelper.id, QualityAnalysisTableHelper)
    .service(ManualInputsDataService.serviceId, ManualInputsDataService)
    .service(WidgetFactory.serviceId, WidgetFactory)
    ;

widgetModule.run(['widgetFactory', (widgetFactory: IWidgetFactory) => {
    _.values<WidgetDefinition>(definitions)
        .forEach(d => {
            const miniature = new Miniature(d.type, d.title, d.icon, d.highlights);
            miniature.sortingOrder = d.sortingOrder;
            miniature.group = d.group;
            miniature.hasImage = d.hasImage;
            miniature.isExperimental = d.isExperimental;
            widgetFactory.register(miniature);
        });
}]);

registerComponents(components, widgetModule);